import axios from "axios";
import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { baseUrl, userName, ipAddress } from "./Univ.js";

function AddBoothDailyUpdate() {
  const [booths, setBooths] = useState([]);
  const [rows, setRows] = useState([]);
  const [form, setForm] = useState({
    booth: "",
    houses_covered: "",
    voters_met: "",
    volunteer_count: "",
    key_issues: "",
    morale: "3",
  });

  // -------- FETCH BOOTHS --------
  useEffect(() => {
    axios.get(baseUrl + "booths/").then(r => setBooths(r.data));
  }, []);
// -------- FETCH DAILY UPDATES --------
const fetchDailyUpdates = () => {
  axios
    .get(baseUrl + "booth-daily/")
    .then((r) => setRows(r.data))
    .catch((err) => console.error(err));
};

useEffect(() => {
  fetchDailyUpdates();
}, []);

  // -------- HANDLE CHANGE --------
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
  };

  // -------- SUBMIT (FormData) --------
  const formSubmit = () => {

    // Basic validation
    if (!form.booth) {
      Swal.fire("Error", "Please select a booth", "error");
      return;
    }

    const _formData = new FormData();
    _formData.append("booth", form.booth);
    _formData.append("houses_covered", form.houses_covered);
    _formData.append("voters_met", form.voters_met);
    _formData.append("volunteer_count", form.volunteer_count);
    _formData.append("key_issues", form.key_issues);
    _formData.append("morale", form.morale);
    _formData.append("status", "1");
    _formData.append("addedby", userName);
    _formData.append("ip_add", ipAddress);

    axios.post(baseUrl + "booth-daily/", _formData)
      .then(response => {
        if (response.status === 200 || response.status === 201) {
          Swal.fire({
            title: "Daily Update Added",
            icon: "success",
            timer: 2000,
            showConfirmButton: false,
          });
            setTimeout(() => window.location.reload(), 1000);
          // Reset form
          setForm({
            booth: "",
            houses_covered: "",
            voters_met: "",
            volunteer_count: "",
            key_issues: "",
            morale: "3",
          });
        }
      })
      .catch(err => {
        console.error(err);
        Swal.fire("Error", "Failed to save daily update", "error");
      });
  };
// ---------------- DELETE HANDLER ----------------
const handleDelete = (id) => {
  Swal.fire({
    title: "Are you sure?",
    text: "This record will be permanently deleted",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#d33",
    cancelButtonColor: "#6c757d",
    confirmButtonText: "Yes, delete it!",
  }).then((result) => {
    if (result.isConfirmed) {
      axios.delete(baseUrl + "delete-booth-daily/" + id + "/")
        .then(() => {
          Swal.fire({
            title: "Deleted!",
            text: "Booth Daily has been removed",
            icon: "success",
            timer: 1500,
            showConfirmButton: false,
          });

        })
        .catch((error) => {
          console.error(error);
          Swal.fire("Error", "Delete failed", "error");
        });
    }
  });
};
// ---------------- DATAGRID COLUMNS ----------------
const columns = [
  { field: "id", headerName: "ID", width: 70 },

  {
    field: "booth",
    headerName: "Booth",
    width: 140,
    renderCell: (params) => (
      <span>
        Booth {params.value?.booth_number || params.value || "-"}
      </span>
    ),
  },

  { field: "houses_covered", headerName: "Houses", width: 120 },
  { field: "voters_met", headerName: "Voters Met", width: 120 },
  { field: "volunteer_count", headerName: "Volunteers", width: 130 },

  {
    field: "morale",
    headerName: "Morale",
    width: 120,
    renderCell: (params) => {
      if (params.value === 1) return "Very Bad";
      if (params.value === 3) return "Neutral";
      if (params.value === 5) return "Very Good";
      return "-";
    },
  },

  {
    field: "actions",
    headerName: "Actions",
    width: 120,
    sortable: false,
    renderCell: (params) => (
      <button
        className="btn btn-sm btn-danger"
        onClick={() => handleDelete(params.id)}
      >
        Delete
      </button>
    ),
  },
];

  return (
    <section className="container mt-4">
      <div className="card">
        <h4 className="card-header">Booth Daily Update</h4>

        <div className="card-body">

          <select
            className="form-control mb-3"
            name="booth"
            value={form.booth}
            onChange={handleChange}
          >
            <option value="">-- Select Booth --</option>
            {booths.map(b => (
              <option key={b.id} value={b.id}>
                Booth {b.booth_number}
              </option>
            ))}
          </select>

          <input
            type="number"
            className="form-control mb-3"
            name="houses_covered"
            placeholder="Houses Covered"
            value={form.houses_covered}
            onChange={handleChange}
          />

          <input
            type="number"
            className="form-control mb-3"
            name="voters_met"
            placeholder="Voters Met"
            value={form.voters_met}
            onChange={handleChange}
          />

          <input
            type="number"
            className="form-control mb-3"
            name="volunteer_count"
            placeholder="Volunteer Count"
            value={form.volunteer_count}
            onChange={handleChange}
          />

          <textarea
            className="form-control mb-3"
            name="key_issues"
            placeholder="Key Issues Observed"
            value={form.key_issues}
            onChange={handleChange}
          />

          <select
            className="form-control mb-3"
            name="morale"
            value={form.morale}
            onChange={handleChange}
          >
            <option value="1">Very Bad</option>
            <option value="3">Neutral</option>
            <option value="5">Very Good</option>
          </select>

          <button className="btn btn-primary" onClick={formSubmit}>
            Save Daily Update
          </button>

        </div>
      </div>
      <div className="mt-4">
  <DataGrid
    rows={rows}
    columns={columns}
    autoHeight
    pageSize={25}
    rowsPerPageOptions={[25, 50, 100]}
    components={{ Toolbar: GridToolbar }}
    sx={{
      boxShadow: 4,
      border: 4,
      borderColor: "primary.light",
      "& .MuiDataGrid-cell:hover": {
        color: "primary.main",
      },
    }}
  />
</div>

    </section>
  );
}

export default AddBoothDailyUpdate;
